export const endPoints={
    enquiryList:"/enquiry/list",
    service:"services",
    user:"user",
    booking:"booking",
    subscription:"/plans/subscribe"
    
}